import { Card, Checkbox, Flex, Input, Modal, Row, Spin } from "antd";
import Meta from "antd/es/card/Meta";
import { useFormik } from "formik";
import { useState } from "react";
import * as Yup from "yup";
import { IBlock, useGetImages } from "../api/api.get";

import { useNotifications } from "../hooks/notification";
import { useNavigate } from "react-router-dom";

const games = [{ name: "Number Press", id: 1 },
  { name: "Number Draw", id: 2 }
];

export default function ShoppingPage() {
  const [item, setItem] = useState<IBlock>();
  const { notifySuccess, notification, notifyError } = useNotifications({
    title: "Thank you for your message. We will get back to you asap.",
  });
  const navigate = useNavigate();

  return (
    <div className="p-20">
      {notification}
      <ItemModal
        open={!!item}
        block={item}
        onConfirm={() => {
          setItem(undefined);
          notifySuccess();
        }}
        onError={() => {
          setItem(undefined);
          notifyError();
        }}
        onCancel={() => setItem(undefined)}
      />
      <div className="p-0">
        <div
          className="center-align p-20 column"
          style={{ backgroundColor: "aliceblue", borderRadius: 20 }}
        >
          <Flex vertical>
            <h2>Free Games!</h2>
          </Flex>

          <Row gutter={[20, 20]}>
            {games.map((game) => {
              return (
                <div className="mx-20 my-20">
                  <Card
                    hoverable
                    style={{ width: 240 }}
                    onClick={() => navigate(`/games/${game.id}`)}
                  >
                    <Meta title={game.name} />
                  </Card>
                </div>
              );
            })}
          </Row>
        </div>
      </div>
    </div>
  );
}

interface IProps {
  open: boolean;
  block?: IBlock;
  onConfirm: () => void;
  onCancel: () => void;
  onError: () => void;
}

function ItemModal({ open, onError, onConfirm, onCancel, block }: IProps) {
  const formik = useFormik({
    initialValues: {
      customerPhone: "",
      sku: block?.data.caption,
      phoneVerified: false,
      message: `Hi Priya! I'm interested in the item ${block?.data.caption}. Please reach out to me in the following number.`,
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      customerPhone: Yup.string()
        .matches(/^[0-9]+$/, "Phone number must be digits")
        .required("Please enter phone")
        .min(10, "Invalid phone number")
        .max(10, "Invalid phone number"),
      phoneVerified: Yup.bool().required("Please accept terms."),
    }),
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: async (values) => {
      fetch(
        "https://script.google.com/macros/s/AKfycbxJZCmpI3_p9WqfyHyr-AzxTQVp_M0RIJ1XEfHBTdj3R5HGWhEgKRAR1xMZLmkqZj4D/exec",
        {
          method: "POST",
          mode: "no-cors",
          body: JSON.stringify(values),
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
        .then(() => {
          formik.resetForm();
          onConfirm();
        })
        .catch(() => {
          onError();
        });
    },
  });

  console.log(formik.errors);

  const [acceptTerms, setAcceptTerms] = useState(false);

  return (
    <Modal
      title={block?.data.caption}
      open={open}
      onOk={formik.submitForm}
      onCancel={onCancel}
      okText={"Send"}
      cancelText="Close"
      okButtonProps={{
        disabled: Object.values(formik.errors).length > 0 || !acceptTerms,
      }}
    >
      <div className="p-20">
        <img src={block?.data.url} width={300} />

        <Flex gap={30} vertical className="mt-40">
          <Input.TextArea size="middle" {...formik.getFieldProps("message")} />

          <Flex gap={0} vertical>
            <Input
              size="middle"
              prefix={"+1"}
              placeholder="Enter your phone number..."
              {...formik.getFieldProps("customerPhone")}
            />
            <ErrorPanel message={formik.errors.customerPhone} />
          </Flex>

          <Flex gap={10} vertical>
            <Checkbox onChange={(e) => setAcceptTerms(!acceptTerms)}>
              By checking this box, I confirm I am not impersonating another
              individual or using someone else's contact information for this.
            </Checkbox>
          </Flex>
        </Flex>
      </div>
    </Modal>
  );
}

export function ErrorPanel({ message }: { message?: string }) {
  return (
    <div style={{ minHeight: 0, marginTop: 0 }}>
      {message && (
        <span className="errorMsg" style={{ fontSize: "small" }}>
          {message}
        </span>
      )}
    </div>
  );
}
